/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Nav_Referral_CodesInputs */



/**
* | output |
* | --- |
* | "Referral codes" |
*
* @param {Partner_Nav_Referral_CodesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_nav_referral_codes = /** @type {((inputs?: Partner_Nav_Referral_CodesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Nav_Referral_CodesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Empfehlungscodes")
	return /** @type {LocalizedString} */ ("Referral codes")
});